const storeSources = () => {
    const referrer = document.referrer;
    const currentDomain = window.location.hostname;
   
    if (referrer && !referrer.includes(currentDomain)) {
        const expiryTime = new Date();
        expiryTime.setTime(expiryTime.getTime() + 24 * 60 * 60 * 1000); // 24 hours in milliseconds

        const cookieValue = {
            referrer: referrer,
            dateRecorded: new Date().toUTCString(), // Recording the date directly
        };
        const encodedCookieValue = encodeURIComponent(JSON.stringify(cookieValue));
        document.cookie = `donation_source=${encodedCookieValue}; expires=${expiryTime.toUTCString()}; path=/;`;
    }
    else {
        const expiryTime = new Date();
        expiryTime.setTime(expiryTime.getTime() + 0); // set to 0 

        const cookieValue = {
            referrer: referrer,
            dateRecorded: new Date().toUTCString(), // Recording the date directly
        };
        const encodedCookieValue = encodeURIComponent(JSON.stringify(cookieValue));
        document.cookie = `donation_source=${encodedCookieValue}; expires=${expiryTime.toUTCString()}; path=/;`
    }
};

const decodeSourceCookie = () => {
    const cookie = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith('donation_source='));

    if (cookie) {
        const sourceCookieValue = cookie.split('=')[1];
        return JSON.parse(decodeURIComponent(sourceCookieValue));
    }

    return null;
}

const collectSourceURL = () => {
    const sourceCookie = decodeSourceCookie();

    if (sourceCookie && sourceCookie.referrer) {
        const referrerURL = new URL(sourceCookie.referrer);

        return referrerURL.href;
    }

    return null; // Return 'Direct' if sourceCookie or referrer is unavailable
}

const collectSourceDate = () => {
    const sourceCookie = decodeSourceCookie();
    const sourceURL = collectSourceURL();

    if (sourceCookie && sourceCookie.dateRecorded && sourceCookie.dateRecorded && sourceURL) {
        return sourceCookie.dateRecorded;
    }

    return null; // Return current date if dateRecorded is unavailable
}

export {storeSources, decodeSourceCookie, collectSourceURL, collectSourceDate} ;
